import React from 'react';

export const contextFactory = <T>(): [() => T, React.Context<T>] => {
    const context = React.createContext<T>(undefined);

    const useContext = () => {
        const ctx = React.useContext<T>(context);

        if (ctx === undefined) {
            throw new Error('useContext must be used inside of a Provider with a value.');
        }
        return ctx;
    };

    return [useContext, context];
};
